// UserContext.tsx
import React, { createContext, useState, useContext, ReactNode, useEffect } from 'react';
import { User } from "../model/User";
import CryptoJS from 'crypto-js';
import { useAuth0 } from './useAuth0';

// Interface do contexto
interface UserContextType {
    user: User | null;
    setUser: (user: User | null) => void;
}
// // Criar o contexto
export const UserContext = createContext<UserContextType | undefined>(undefined);

//
// // Função para buscar e descriptografar o usuário do localStorage

//
// // Provider do contexto
// export const UserProvider = ({ children }: { children: ReactNode }) => {
//     const [user, setUser] = useState<User | null>(() => getUserFromLocalStorage()); // Inicializa com localStorage
//     console.log("UserProvider: user", user);
//     // Atualiza o localStorage sempre que o user mudar
//     useEffect(() => {
//         saveUserToLocalStorage(user);
//     }, [user]);
//
//     return (
//         <UserContext.Provider value={{ user, setUser }}>
//             {children}
//         </UserContext.Provider>
//     );
// };

export const UserProvider = ({ children }: { children: ReactNode }) => {
    const { user: auth0User, isAuthenticated } = useAuth0();
    /**
     * The backend-side User profile (id, lastLoginOn, language…).
     * LoadInitialData calls setUser(checkUser-result) on app boot.
     * We merge it with the Auth0 profile when reading so any consumer
     * sees the freshest of both — without the previous bug where each
     * render replaced the backend data with the bare Auth0 fields.
     */
    const [backendUser, setBackendUser] = useState<User | null>(null);

    const auth0Defaults: User | null =
        isAuthenticated && auth0User
            ? {
                  email: auth0User.email || '',
                  firstName: auth0User.given_name || '',
                  lastName: auth0User.family_name || '',
                  image: auth0User.picture || '',
              }
            : null;

    const user: User | null = backendUser
        ? { ...auth0Defaults, ...backendUser }
        : auth0Defaults;

    return (
        <UserContext.Provider value={{ user, setUser: setBackendUser }}>
            {children}
        </UserContext.Provider>
    );
};

// Hook para usar o contexto do usuário
export const useUser = () => {
    const context = useContext(UserContext);
    if (!context) {
        throw new Error("useUser must be used within a UserProvider");
    }
    return context;
};
